import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const infobloxBloxone = defineConnector({
  identifier: "infobloxBloxone",
  name: "Infoblox BloxOne",
  tagLine: "Cloud-managed DNS and security",
  logo,
  protocol: "http",
  tags: ["it", "security"],
  defaultUrlPattern: () => "https://csp\\.infoblox\\.com/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: `Token ${app.secret.apiKey}`,
      },
    ]),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Infoblox Cloud Services Portal](https://csp.infoblox.com), go to **Administration → API Keys** and create a new API key.",
        },
      ],
    },
    {
      title: "Paste your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://csp.infoblox.com/api/iam/v2/current_user",
  },
});
